import { render, staticRenderFns } from "./eisNew.vue?vue&type=template&id=58a36630"
import script from "./eisNew.vue?vue&type=script&lang=js"
export * from "./eisNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports